"use strict";
/**
 * Component: AppSnackBar
 * Fitxer: AppSnackBar.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_react_1 = require("mobx-react");

var notistack_1 = require("notistack"); // import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';
// import WarningIcon from '@material-ui/icons/ReportProblemOutlined';
// import ErrorIcon from '@material-ui/icons/ErrorOutline';
// import InfoIcon from '@material-ui/icons/InfoOutlined';
// defineix per on es mostrarà l'snakcbar


exports.snackbarAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'center'
};

var AppSnackBar = function AppSnackBar(props) {
  if (!props.appState) {
    return null;
  }

  var notiState = props.appState.notiState;
  notiState.providerContext = notistack_1.useSnackbar();
  return null;
};

exports.default = mobx_react_1.inject('appState')(AppSnackBar);